import React, { Component } from "react";
import { Col, Row } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { get } from "lodash";

import {
    InputBoxWithState,
    FormWrapper,
    SelectBoxWithState,
    InputButtonWithState
} from "../../../../components/boda-boda/Forms";
import {
    getRoleListAPI, getUserStaffList, getMerchantBranchAllAPI, countryCodeAPI
} from "../../../../config/boda-boda/apiUrls.config";
import { createUserTrKey } from "../../../../store/boda-boda/transaction_request/actionTypes";
import { BackBtnComponent } from "../../../../components/boda-boda/CommonElements/BaseElements";


class CreateUI extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let { history } = this.props;

        return (
            <div className="container-fluid">
                <Row className="align-items-center">
                    <Col sm={6}>
                        <div className="page-title-box" style={{ padding: "24px 0 15px 0" }}>
                            <h4 className="font-size-18">Create a Staff</h4>
                        </div>
                    </Col>

                    <Col sm={6}>
                        <div className={"d-flex justify-content-end"}>
                            <CreateBtn
                                historyFn={history}
                            />

                            <BackBtnComponent
                                elementWrapperStyle={""}
                                path={"/users"}
                                btnName={"Cancel"}
                                icon={"far fa-times-circle"}
                                btnColor={"danger"}
                            />
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col sm={12}>
                        <div className="card">
                            <div className="card-body">
                                <FormWrapper
                                    setGroupName={`${getUserStaffList.key}_create`}
                                    onDestroyUnsetFormObject={true}
                                >
                                    <div className="row">
                                        <div className="col-md-6">
                                            <SelectBoxWithState
                                                labelText={"Role"}
                                                inputName={"role"}
                                                formGroupName={`${getUserStaffList.key}_create`}
                                                apiUrl={`${getRoleListAPI.url}/all?type=MERCHANT`}
                                                apiStateKey={getRoleListAPI.key}
                                                keyName={"id"}
                                                valueName={"name"}
                                                placeHolderText={"Role"}
                                                isRequired={true}
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <InputBoxWithState
                                                labelText="Name"
                                                placeHolderText={"Name"}
                                                //inputStatePath={`${getUserStaffList.key}_create.test.name`}
                                                inputName={"name"}
                                                formGroupName={`${getUserStaffList.key}_create`}
                                                isRequired={true}
                                                maxLength={100}
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <InputBoxWithState
                                                labelText="Identification"
                                                placeHolderText={"Identification"}
                                                inputName={"identification"}
                                                formGroupName={`${getUserStaffList.key}_create`}
                                                isRequired={true}
                                                maxLength={20}
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <div className={"row"}>
                                                <div className={"col-md-3"}>
                                                    <SelectBoxWithState
                                                        isRequired={true}
                                                        labelText="Country Code"
                                                        inputStatePath={`${getUserStaffList.key}_create.countryCode.id`}
                                                        formGroupName={`${getUserStaffList.key}_create`}
                                                        apiUrl={`${countryCodeAPI.url}/all`}
                                                        apiStateKey={countryCodeAPI.key}
                                                        onRebuildResponseFn={(response) => {
                                                            const data = [];

                                                            response.forEach((value) => {
                                                                data.push({
                                                                    id: `${value.id}/${value.code}/${value.prefix}`,
                                                                    value: value.code
                                                                });
                                                            });

                                                            return {
                                                                "data": {
                                                                    "data": data
                                                                }
                                                            }
                                                        }}
                                                    />
                                                </div>

                                                <div className={"col-md-9"}>
                                                    <InputBoxWithState
                                                        labelText="Phone"
                                                        inputName={"phone"}
                                                        placeHolderText={"Enter Phone"}
                                                        formGroupName={`${getUserStaffList.key}_create`}
                                                        isRequired={true}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <SelectBoxWithState
                                                labelText="Branch"
                                                inputName={"merchantBranch"}
                                                placeHolderText={"Branch"}
                                                formGroupName={`${getUserStaffList.key}_create`}
                                                apiUrl={getMerchantBranchAllAPI.url}
                                                apiStateKey={getMerchantBranchAllAPI.key}
                                                keyName={"id"}
                                                valueName={"name"}
                                                isRequired={true}
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <InputBoxWithState
                                                labelText="Email"
                                                inputName={"email"}
                                                placeHolderText={"Email"}
                                                formGroupName={`${getUserStaffList.key}_create`}
                                                maxLength={50}
                                                isRequired={true}
                                            />
                                        </div>

                                        {/* <div className="col-md-6">
                                            <SelectBoxWithState
                                                labelText="Category"
                                                inputName={"category"}
                                                placeHolderText={"Select a Category"}
                                                formGroupName={`${getUserStaffList.key}_create`}
                                                dataList={staffCategories}
                                            />
                                        </div> */}

                                        {/* <div className="col-md-6">
                                            <SelectBoxWithState
                                                labelText="Status"
                                                inputName={"status"}
                                                placeHolderText={"Select a Status"}
                                                formGroupName={`${getUserStaffList.key}_create`}
                                                dataList={userStatusList}
                                            />
                                        </div> */}

                                        <div className="col-md-12">
                                            <hr />
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <InputBoxWithState
                                                        labelText="Credential"
                                                        inputName={"credential"}
                                                        placeHolderText={"Credential"}
                                                        formGroupName={`${getUserStaffList.key}_create`}
                                                        isRequired={true}
                                                        maxLength={50}
                                                    />
                                                </div>

                                                <div className="col-md-6">
                                                    <InputBoxWithState
                                                        labelText="Password"
                                                        inputName={"password"}
                                                        placeHolderText={"Enter Password"}
                                                        inputType={"password"}
                                                        formGroupName={`${getUserStaffList.key}_create`}
                                                        isRequired={true}
                                                        maxLength={50}
                                                    />
                                                </div>

                                                <div className="col-md-6">
                                                    <InputBoxWithState
                                                        labelText="Confirm Password"
                                                        inputName={"confirm_password"}
                                                        placeHolderText={"Enter Confirm Password"}
                                                        inputType={"password"}
                                                        formGroupName={`${getUserStaffList.key}_create`}
                                                        isRequired={true}
                                                        maxLength={50}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </FormWrapper>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}

const CreateBtn = (props) => {
    const authState = useSelector(state => state.AuthState);
    const dispatch = useDispatch();

    return (
        <InputButtonWithState
            elementWrapperStyle={"mr-2"}
            btnText={"Save"}
            startIcon={"mdi mdi-content-save-all-outline"}
            formGroupName={`${getUserStaffList.key}_create`}
            onClickBtnFn={(dataObject) => {
                dispatch({
                    type: createUserTrKey,
                    payload: {
                        ...dataObject.formObject,
                        merchant: get(authState, "authUser.merchant.id", ""),
                        historyFn: props.historyFn
                    }
                })
            }}
        />
    )
}

export { CreateUI };
